<template>
    <button :type="type" :class="['primary-btn text-center mb-4', wrapperClass]" @click="emitClickEvent" :disabled="disabled">
        {{ text }}
    </button>
</template>

<script>

export default {
  name: 'PrimaryButton',
  props: {
    type: {
        type: String,
        default: "button"
    },
    text: {
        type: String,
        default: ""
    },
    wrapperClass: {
        type: String,
        default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitClickEvent() {
      if (this.disabled) {
        return;
      }
      this.$emit('click')
    }
  }
 
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>